const CALENDAR_DATE = new Intl.DateTimeFormat('es-AR', { timeZone: 'UTC' });

/**
 * Formats a calendar day (`serviceDate`) as `d/m/yyyy`.
 *
 * The API sends these as UTC midnight. Formatting them in the browser's zone
 * would move every date one day back in Argentina (UTC-3), so the day is read
 * in UTC, where it was written. Own domain copy, same convention as
 * `orders/format-calendar-date.ts`/`contracts/format-calendar-date.ts`: one
 * UTC-midnight formatter per domain rather than a shared one.
 */
export function formatCalendarDate(value: string): string {
  return CALENDAR_DATE.format(new Date(value));
}
